import { FC } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReturnItemTable } from './ReturnItemTable';
import { ReturnItemTableDialogProps } from './types';

export const ReturnItemTableDialog: FC<ReturnItemTableDialogProps> = ({
	open,
	onClose,
	title,
	items,
	loading,
	currency,
}) => {
	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="xl"
			PaperProps={{
				sx: { borderRadius: '12px', minHeight: '20vh' },
			}}
		>
			<Box
				sx={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					pr: 1,
				}}
			>
				<DialogTitle sx={{ fontWeight: 'bold' }}>{title ?? 'Return Item Table'}</DialogTitle>
				<IconButton onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</Box>
			<DialogContent dividers sx={{ p: 0 }}>
				<ReturnItemTable items={items} loading={loading} currency={currency} />
			</DialogContent>
		</Dialog>
	);
};

